// ..................................................................

var swiper = new Swiper(".featured--icon", {
  slidesPerView: 5,
  spaceBetween: 20,
  breakpoints: {
    0: {
      slidesPerView: 2.5,
      spaceBetween: 15,
      grabCursor: true,
      loop: true
    },
    550: {
      slidesPerView: 9,
    },
  },
});

// ..................................................................

var swiper = new Swiper(".product-banner-slider", {
  slidesPerView: 1.8,
  spaceBetween: 100,
  loop: true,
  centeredSlides: true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// ..................................................................

$(".accordion--main h5").click(function(){
  $(this).parent(".accordion--main").children(".custom-accordion-content").slideToggle();
  $(this).children(".custom-accordion-arrow").toggleClass("active-accordion");
});

// ..................................................................



// ..................................................................



// ..................................................................



// ..................................................................



// ..................................................................



// ..................................................................



// ..................................................................



// ..................................................................



// ..................................................................


